module.exports = __webpack_public_path__ + "static/media/logo_mosty_colored.415459e4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logo_mosty_colored.svg
// module id = 712
// module chunks = 0